import React from "react";
import { Input } from "@emisgroup/ui-input";
import { InputType } from "../Types";

interface CustomInputProps {
/**
 * Data test id for the current input field
 */
  dataTestId?: string;
  /**
   * Input type for the current input field Example: text, number etc
   */
  type?: InputType;
  /**
   * Name for the current input field
   */
  name?: string;
  /**
   * Id for the current input field
   */
  id?: string;
  /**
   * Event handler while onChanging the current input field
   */
  onChange?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  /**
   * Current value that is available in the input field
   */
  value?: string | number | readonly string[];
  /**
   * Responsible for the current input field to be enabled or disabled
   */
  disabled?: boolean;
  /**
   * Responsible for the current input field to be in readOnly mode
   */
  readOnly?: boolean;
  /**
   * Current input field to be valid or invalid
   */
  invalid?: boolean;
  /**
   * Placeholder for the current input field
   */
  placeholder?: string;
  /**
   * Current input field is mandatory or not
   */
  required?: boolean;
  /**
   * Classname for the current input field
   */
  className?: string;
  /**
   * Event handler while onBlur the current input field
   */
  onBlur?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  /**
   * Current input field's allowed max length
   */
  maxLength?: number;
  /**
   * Default string value for the given input
   */
  defaultValue?: string;
  /**
   * Aria label for the given input component
   */
  ariaLabel?: string;
  /**
   * Icons to render if  any
   */
  children?: React.ReactNode;
  /**
   * To clear values in the current input field
   */
  clearable?: boolean;
  /**
   * Callback for when the clear button is clicked
   */
  onClear?: () => void;
}

/**
 * Responsible for rendering the input element
 * @returns input element
 */
export const UIInput: React.FC<CustomInputProps> = (props: CustomInputProps) => {

  const {
    type,
    name,
    id,
    dataTestId,
    onChange,
    value,
    disabled,
    readOnly,
    invalid,
    placeholder,
    required,
    className,
    onBlur,
    maxLength,
    defaultValue,
    ariaLabel,
    children,
    clearable,
    onClear
  } = props;

  return (
    <Input
      data-testid={dataTestId}
      id={id}
      type={type}
      name={name}
      value={value}
      disabled={disabled}
      onChange={onChange}
      readOnly={readOnly}
      invalid={invalid}
      placeholder={placeholder}
      required={required}
      className={className}
      onBlur={onBlur}
      maxLength={maxLength}
      defaultValue={defaultValue}
      aria-label={ariaLabel}
      clearable={clearable}
      onClear={onClear}
    >
      {children}
    </Input>
  );
};
